import { ContentCopy, Delete, DragIndicator, Edit } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";

export default function Actions({onDelete, onEdit, onDrag, onDrop, onCopy}){

    return <Stack direction='row' alignItems='center'>

        {onCopy && 
            <IconButton onClick={onCopy} size='small'>
                <ContentCopy />
            </IconButton>
        }

        {onEdit && 
            <IconButton onClick={onEdit} size='small'>
                <Edit />
            </IconButton>
        }

        {onDelete && 
            <IconButton onClick={onDelete} size='small'>
                <Delete />
            </IconButton>
        }

        {onDrag && 
            <IconButton 
                onMouseEnter={onDrag}
                onMouseLeave={onDrop}
                onMouseDown={onDrag}
                onMouseUp={onDrop}
                size='small'
            >
                <DragIndicator />
            </IconButton>
        }
        
    </Stack>
}